import React from 'react';
import { Link } from 'react-router-dom';

const FiveHelpfulTipsPage = () => {
  return (
    <div>
      {/* Article Header */}
      <section
        className="h-[42vh] sm:h-[49vh] md:h-[56vh] bg-cover bg-center bg-no-repeat relative"
        style={{
          backgroundImage: "url('/images/LJM-Blog-Images.webp')"
        }}
      >
        {/* Overlay */}
        <div
          className="absolute inset-0"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
        />

        {/* Banner Content */}
        <div className="relative z-10 flex items-center h-full px-4 sm:px-8 md:px-16 lg:px-24">
          <div className="text-center text-white max-w-6xl mx-auto">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal mb-4 sm:mb-6 leading-tight text-white">
              5 helpful tips on buying new customers
            </h1>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-8 sm:py-10 md:py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="blog_inner">
            <div className="blog_lift_sidebar">
              <div className="blog_items">
                <div className="prose prose-lg max-w-none">
                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    This year, one of your resolutions may have been to increase your client base by buying new customers, but how do you do this is the question on every business owners lips.
                  </p>

                  <p className="text-xl font-semibold text-gray-900 mb-4">
                    <strong>Here are 5 tried and tested tips on how to buy new customers and get them to buy into your brand</strong>
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    With so many opportunities out there make sure your team don't miss out on simple and effective strategies to build your customer base.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-2 text-lg">
                    <strong>Create new opportunities close to home:</strong>
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Why not work with a business that has a similar target customer and can promote your services to their business database? By doing this you are buying new customers for your business through affiliated companies, this builds trust within the industry and may even gain you a few backlinks to help with SEO.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-2 text-lg">
                    <strong>Keep within budget:</strong>
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Set a budget that is cost-effective for you and which captures the customers you're looking to attract.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-2 text-lg">
                    <strong>Benefits For Them:</strong>
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Think about what the benefits are benefits to businesses or consumers that are buying into your business or idea? You can do things like offer new customers discounts and promotions, consumers still look for value and deals. Lure them into your business by offering introductory discounts.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-2 text-lg">
                    <strong>Build presence on subscriber platforms:</strong>
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Think of advertising on websites or in magazines that have lots of subscribers and need someone with your particular services.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-2 text-lg">
                    <strong>Keep the lifetime value of the customer in mind:</strong>
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    It's cheaper to increase a customers lifetime using your business initiatives than it is to acquire a new one. You want to ensure that you attract customers that need your services, can afford to purchase those services and will positively impact the future growth of your business.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Think of these tips and tricks as a starter. Feel free to add your own ideas, as you may have other ways to spark interest within your industry. Get started now so that when 2023 comes, you've already done the hard bit in buying new customers and are already selling to an expanded client base.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Need help with your marketing or sales strategy? at Lloyd James we can harness the power of data to help your business achieved tangible outcomes like driving performance and growth. <Link to="/contact" className="text-pink-600 hover:text-pink-700 underline" onClick={() => window.scrollTo(0, 0)}>Click here to request a callback.</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FiveHelpfulTipsPage;